import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { useReduxSelector } from '@/store/hooks'
import { cleanInternalRedirect } from '@/utils/commonUtil'

import { useLinkInternal } from './useLinkInternal'

const BLOCKED_SIGNEDIN = ['/confirm-password', '/forgot-password', '/signin', '/signup']

type Props = {
  statusRequired: 'signedIn' | 'signedOut'
}

export const useAuthGuard = ({ statusRequired }: Props) => {
  const pathname = usePathname()
  const { redirectUrl } = useLinkInternal()
  const redirect = cleanInternalRedirect(useSearchParams().get('redirect'))
  const status = useReduxSelector((s) => s.user.status)
  const state = status === 'loading' ? 'resolving' : status === statusRequired ? 'allowed' : 'denied'

  useEffect(() => {
    if (state !== 'denied') return
    if (statusRequired === 'signedIn') {
      redirectUrl(`/signin?redirect=${encodeURIComponent(pathname)}`, { replace: true })
      return
    }
    const blocked = !redirect || BLOCKED_SIGNEDIN.some((path) => redirect.startsWith(path))
    redirectUrl(blocked ? '/account' : redirect, { replace: true })
  }, [statusRequired, state, redirect, redirectUrl, pathname])

  return state
}
